<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions" class="h-10">
  <div class="flex h-10 w-10 items-center">
    <img
      class="h-10 w-10 rounded-full bg-gray-100 object-cover ring-2 ring-white"
      [src]="
        currentUserData.avatar ? baseUrl + currentUserData.avatar : 'assets/images/noimage.png'
      "
      referrerpolicy="no-referrer"
    />
  </div>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
  <button mat-menu-item>
    <span class="flex w-full flex-col leading-none">
      <span class="w-full truncate">{{ currentUserData.fullName }}</span>
      <span class="mt-1.5 w-full min-w-44 truncate text-md font-medium" style="line-height: normal">
        {{ currentUserData.email }}
      </span>
    </span>
  </button>

  @if (!isSettingOrProfile) {
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="goToProfile()">
      <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
      <span>{{ 'Profile' | transloco }}</span>
    </button>
  }
  @if (
    !isSettingOrProfile &&
    currentUserData?.userType !== 'BRAND' &&
    currentUserData?.userType !== 'ASSOCIATION'
  ) {
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="goToActivityLog()">
      <mat-icon [svgIcon]="'list'"></mat-icon>
      <span>{{ 'Activity Log' | transloco }}</span>
    </button>
  }

  @if (isAdminUi) {
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="goBackToAdmin()">
      <mat-icon [svgIcon]="'manage_accounts'"></mat-icon>
      <span>{{ 'Back To Admin' | transloco }}</span>
    </button>
  }
  @if (isGroupFound && currentUrlLastPart !== 'view-as') {
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="goToViewAs()">
      <mat-icon [svgIcon]="'manage_accounts'"></mat-icon>

      <span>{{ 'View As' | transloco }}</span>
    </button>
  }
  <mat-divider class="my-2"></mat-divider>
  <button mat-menu-item (click)="signOut()">
    <mat-icon [svgIcon]="'heroicons_outline:logout'"></mat-icon>
    <span>{{ 'Sign out' | transloco }}</span>
  </button>
</mat-menu>
